import * as yup from "yup";

const required = yup.mixed().required("Required");

const getRequiredString = (name) => {
  return name + " is required.";
};

export const treatmentPlanSchema = yup.object().shape({
  // files
  iosScan: yup.object().shape({
    maxillary: required,
    mandibular: required,
    biteScan: required,
  }),
  photography: yup.object().shape({
    fullFace: required,
    fullFaceSmiling: required,
    profile: required,
    occludedAnterior: required,
    occludedRight: required,
    occludedLeft: required,
    occlusalUpper: required,
    occlusalLower: required,
  }),
  additionalFiles: yup.array().of(yup.mixed()),
  // form
  chiefRequest: yup
    .string()
    .required(getRequiredString("Patient chief complaint")),
  // treatmentType: yup
  //   .string()
  //   .nullable()
  //   .required(getRequiredString("Treatment type")),
  upperMidline: yup
    .string()
    .nullable()
    .required(getRequiredString("Upper midline correction")),
  lowerMidline: yup
    .string()
    .nullable()
    .required(getRequiredString("Lower midline correction")),
  canineAndMolar: yup
    .string()
    .nullable()
    .required(getRequiredString("Canine and molar correction")),
  iprPermitted: yup
    .boolean()
    .nullable()
    .required(getRequiredString("IPR permitted")),
  attachmentsPermitted: yup
    .boolean()
    .nullable()
    .required(getRequiredString("Attachments permitted")),
  crowdingResolution: yup
    .array()
    .min(1, "Please choose at least one.")
    .nullable()
    .required(getRequiredString("Crowding resolution")),
  closeUpperSpacing: yup
    .boolean()
    .nullable()
    .required(getRequiredString("Upper spacing")),
  specificUpperSpacing: yup
    .string()
    .nullable()
    .when("closeUpperSpacing", {
      is: (val) => val === false,
      then: yup.string().required("Specific upper spacing is required"),
    }),
  closeLowerSpacing: yup
    .boolean()
    .nullable()
    .required(getRequiredString("Lower spacing")),
  specificLowerSpacing: yup
    .string()
    .nullable()
    .when("closeLowerSpacing", {
      is: (val) => val === false,
      then: yup.string().required("Specific lower spacing is required"),
    }),
  overjet: yup.string().nullable().required(getRequiredString("Overjet")),
  overbite: yup.string().nullable().required(getRequiredString("Overbite")),
  archForm: yup.string().nullable().required(getRequiredString("Arch form")),
  curveOfSpee: yup
    .string()
    .nullable()
    .required(getRequiredString("Curve of spee")),
  futurePlacement: yup
    .string()
    .nullable()
    .required(getRequiredString("Future placement")),
  specificFuturePlacement: yup
    .string()
    .nullable()
    .when("futurePlacement", {
      is: (val) => val === "Yes",
      then: yup.string().required("Specific lower spacing is required"),
    }),
  teethToBeExtracted: yup
    .string()
    .required(getRequiredString("Teeth to be extracted")),
  additionalInstructions: yup.string().nullable(),
});
